import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const TwoContainerSkeleton: ISkeleton[] = [

  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 100%',
    rows: 0,
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mt-xlg',
    style: 'width: 100%; height: 300px;',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mt-xlg',
    style: 'width: 100%; height: 300px;',
  },
];
